import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function OutdoorTvSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("outdoorTv.title")}</title>
        <meta name="keywords" content={t("outdoorTv.keywords")} />
        <meta name="description" content={t("outdoorTv.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1a2d42]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/outdoor-tv-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_11%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#0f1f30]/92 via-[#0f1f30]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("outdoorTv.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("outdoorTv.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("outdoorTv.knowledgeBase.rootLabel")}
        rootColor="#2563eb"
        treeTranslationKey="outdoorTv.knowledgeBase.tree"
        i18nPrefix="outdoorTv.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="outdoorTv"
        images={{
          painPoints: "/solutions/outdoor-tv-pain.jpeg",
          solutions: "/solutions/outdoor-tv-solutions.jpeg",
          cta: "/solutions/outdoor-tv-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 25%",
          solutions: "60% 28%",
          cta: "50% 15%",
        }}
      />
    </>
  );
}
